import type { SportId, SportMetric } from '../types'

export const sports: SportId[] = [
  'running',
  'cycling',
  'swimming',
  'triathlon',
  'crossfit',
  'strength',
  'yoga',
  'pilates',
  'beachTennis',
  'jiujitsu',
  'muayThai',
  'boxing',
]

export const sportMetrics: SportMetric[] = [
  /* Running */
  {
    id: 'running:maxKm',
    sport: 'running',
    label: { 'pt-BR': 'Maior distância', 'en-US': 'Max distance' },
    kind: 'distance',
    value: 18,
    chart: true,
  },
  {
    id: 'running:pace',
    sport: 'running',
    label: { 'pt-BR': 'Pace médio', 'en-US': 'Average pace' },
    kind: 'pace',
    value: 332,
    chart: true,
  },
  {
    id: 'running:longRun',
    sport: 'running',
    label: { 'pt-BR': 'Long run', 'en-US': 'Long run' },
    kind: 'distance',
    value: 16.4,
  },
  {
    id: 'running:split',
    sport: 'running',
    label: { 'pt-BR': 'Split médio', 'en-US': 'Average split' },
    kind: 'pace',
    value: 338,
  },
  {
    id: 'running:pr5k',
    sport: 'running',
    label: { 'pt-BR': 'PR 5 km', 'en-US': '5 km PR' },
    kind: 'duration',
    value: 1540,
  },
  {
    id: 'running:pr10k',
    sport: 'running',
    label: { 'pt-BR': 'PR 10 km', 'en-US': '10 km PR' },
    kind: 'duration',
    value: 2892,
    chart: true,
  },
  {
    id: 'running:pr21k',
    sport: 'running',
    label: { 'pt-BR': 'PR 21 km', 'en-US': '21 km PR' },
    kind: 'duration',
    value: 6750,
  },
  {
    id: 'running:pr42k',
    sport: 'running',
    label: { 'pt-BR': 'PR 42 km', 'en-US': '42 km PR' },
    kind: 'duration',
    value: 0,
  },

  /* Cycling */
  {
    id: 'cycling:ftp',
    sport: 'cycling',
    label: { 'pt-BR': 'FTP', 'en-US': 'FTP' },
    kind: 'power',
    value: 212,
    chart: true,
  },
  {
    id: 'cycling:wkg',
    sport: 'cycling',
    label: { 'pt-BR': 'W/kg', 'en-US': 'W/kg' },
    kind: 'ratio',
    value: 3.4,
    chart: true,
  },

  /* Swimming */
  {
    id: 'swimming:pace',
    sport: 'swimming',
    label: { 'pt-BR': 'Pace de natação', 'en-US': 'Swim pace' },
    kind: 'swimPace',
    value: 118,
    chart: true,
  },
  {
    id: 'swimming:splits',
    sport: 'swimming',
    label: { 'pt-BR': 'Split médio', 'en-US': 'Average split' },
    kind: 'swimPace',
    value: 121,
  },
  {
    id: 'swimming:strokeRate',
    sport: 'swimming',
    label: { 'pt-BR': 'Stroke rate', 'en-US': 'Stroke rate' },
    kind: 'plain',
    value: 34,
  },

  /* CrossFit */
  {
    id: 'crossfit:vo2',
    sport: 'crossfit',
    label: { 'pt-BR': 'VO2 máx', 'en-US': 'VO2 max' },
    kind: 'plain',
    value: 42,
    chart: true,
  },
  {
    id: 'crossfit:1rm',
    sport: 'crossfit',
    label: { 'pt-BR': 'Clean 1RM', 'en-US': 'Clean 1RM' },
    kind: 'weight',
    value: 52,
    chart: true,
  },

  /* Strength training */
  {
    id: 'strength:frequency',
    sport: 'strength',
    label: { 'pt-BR': 'Frequência semanal', 'en-US': 'Weekly frequency' },
    kind: 'plain',
    value: 4,
    chart: true,
  },
  {
    id: 'strength:volume',
    sport: 'strength',
    label: { 'pt-BR': 'Volume semanal', 'en-US': 'Weekly volume' },
    kind: 'weight',
    value: 12400,
    chart: true,
  },
  {
    id: 'strength:squat',
    sport: 'strength',
    label: { 'pt-BR': 'Agachamento 1RM', 'en-US': 'Squat 1RM' },
    kind: 'weight',
    value: 95,
    chart: true,
  },
  {
    id: 'strength:bench',
    sport: 'strength',
    label: { 'pt-BR': 'Supino 1RM', 'en-US': 'Bench 1RM' },
    kind: 'weight',
    value: 52,
  },
  {
    id: 'strength:deadlift',
    sport: 'strength',
    label: { 'pt-BR': 'Terra 1RM', 'en-US': 'Deadlift 1RM' },
    kind: 'weight',
    value: 120,
    chart: true,
  },

  /* Triathlon */
  {
    id: 'triathlon:sprint',
    sport: 'triathlon',
    label: { 'pt-BR': 'Melhor tempo · Sprint', 'en-US': 'Best time · Sprint' },
    kind: 'duration',
    value: 4980,
    chart: true,
  },
  {
    id: 'triathlon:olympic',
    sport: 'triathlon',
    label: { 'pt-BR': 'Melhor tempo · Olímpico', 'en-US': 'Best time · Olympic' },
    kind: 'duration',
    value: 0,
    chart: true,
  },
  {
    id: 'triathlon:weeklySessions',
    sport: 'triathlon',
    label: { 'pt-BR': 'Sessões por semana', 'en-US': 'Sessions per week' },
    kind: 'plain',
    value: 6,
  },

  /* Yoga */
  {
    id: 'yoga:sessionsMonth',
    sport: 'yoga',
    label: { 'pt-BR': 'Práticas no mês', 'en-US': 'Sessions this month' },
    kind: 'plain',
    value: 10,
    chart: true,
  },
  {
    id: 'yoga:longestSession',
    sport: 'yoga',
    label: { 'pt-BR': 'Prática mais longa', 'en-US': 'Longest session' },
    kind: 'duration',
    value: 3600,
    chart: true,
  },

  /* Pilates */
  {
    id: 'pilates:sessionsMonth',
    sport: 'pilates',
    label: { 'pt-BR': 'Aulas no mês', 'en-US': 'Classes this month' },
    kind: 'plain',
    value: 8,
    chart: true,
  },
  {
    id: 'pilates:longestSession',
    sport: 'pilates',
    label: { 'pt-BR': 'Aula mais longa', 'en-US': 'Longest class' },
    kind: 'duration',
    value: 3300,
  },

  /* Beach Tennis */
  {
    id: 'beachTennis:matchesMonth',
    sport: 'beachTennis',
    label: { 'pt-BR': 'Jogos no mês', 'en-US': 'Matches this month' },
    kind: 'plain',
    value: 12,
    chart: true,
  },
  {
    id: 'beachTennis:longestMatch',
    sport: 'beachTennis',
    label: { 'pt-BR': 'Jogo mais longo', 'en-US': 'Longest match' },
    kind: 'duration',
    value: 5400,
    chart: true,
  },

  /* Jiu-jitsu */
  {
    id: 'jiujitsu:sessionsMonth',
    sport: 'jiujitsu',
    label: { 'pt-BR': 'Treinos no mês', 'en-US': 'Sessions this month' },
    kind: 'plain',
    value: 12,
    chart: true,
  },
  {
    id: 'jiujitsu:rolls',
    sport: 'jiujitsu',
    label: { 'pt-BR': 'Rolas por treino', 'en-US': 'Rolls per session' },
    kind: 'plain',
    value: 5,
    chart: true,
  },

  /* Muay Thai */
  {
    id: 'muayThai:sessionsMonth',
    sport: 'muayThai',
    label: { 'pt-BR': 'Treinos no mês', 'en-US': 'Sessions this month' },
    kind: 'plain',
    value: 8,
    chart: true,
  },
  {
    id: 'muayThai:rounds',
    sport: 'muayThai',
    label: { 'pt-BR': 'Rounds por treino', 'en-US': 'Rounds per session' },
    kind: 'plain',
    value: 6,
    chart: true,
  },

  /* Boxing */
  {
    id: 'boxing:sessionsMonth',
    sport: 'boxing',
    label: { 'pt-BR': 'Treinos no mês', 'en-US': 'Sessions this month' },
    kind: 'plain',
    value: 6,
    chart: true,
  },
  {
    id: 'boxing:rounds',
    sport: 'boxing',
    label: { 'pt-BR': 'Rounds por treino', 'en-US': 'Rounds per session' },
    kind: 'plain',
    value: 8,
    chart: true,
  },
]

export function metricsForSport(sport: SportId): SportMetric[] {
  return sportMetrics.filter((metric) => metric.sport === sport)
}

export function findSportMetric(id: string): SportMetric | undefined {
  return sportMetrics.find((metric) => metric.id === id)
}
